export default {
      id: "oc-icon_open-usage",
      viewBox: "0 0 15 14",
      url: __webpack_public_path__ + "sprite.svg#oc-icon_open",
      toString: function () {
        return this.url;
      }
    }